// extracted by mini-css-extract-plugin
module.exports = {"icons":"Icons_icons__eVlK-"};